module.exports = __webpack_public_path__ + "img/icons_type-of-sports.4e095646.svg";